// ============================================
// SHARED HELPERS for Analytics Components
// ============================================

export const CHART_COLORS = {
    BLUE: "#1A56DB",
    TEAL: "#0891B2",
    GREEN: "#059669",
    CORAL: "#F97066",
};

// Format numbers with commas
export const fmt = (n) => n?.toLocaleString?.() ?? n;

// Format duration in seconds to "Xm XXs"
export const fmtDuration = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = Math.round(seconds % 60);
    return `${m}m ${s.toString().padStart(2, "0")}s`;
};

// Custom Tooltip component for recharts
export const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload?.length) return null;
    return (
        <div style={{
            background: "#0F1923", color: "white", padding: "12px 16px", borderRadius: 10,
            fontSize: 13, boxShadow: "0 8px 24px rgba(0,0,0,0.25)", border: "none",
        }}>
            <div style={{ fontWeight: 700, marginBottom: 6, color: "#94A3B8" }}>{label}</div>
            {payload.map((p, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", gap: 20, lineHeight: 1.6 }}>
                    <span style={{ color: p.color || "#94A3B8" }}>● {p.name || p.dataKey}</span>
                    <span style={{ fontWeight: 700 }}>{fmt(p.value)}</span>
                </div>
            ))}
        </div>
    );
};
